import React from 'react';
import '../../styles/corpoClinico.css';
import SemFoto from '../../img/corpoClinico/sem_foto.jpg';

const CorpoClinico: React.FC = () => {
  return (
    <>
      <div className='title_clinic'>
        <h2 className="titulo" id="Corpo_Clinico_Fisio">Corpo Clinico</h2>
      </div>
      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={SemFoto} alt="Dr. Henrique" />
            </div>
            <div className="info-container">
              <h3 className="nome">Henrique Güths</h3>
              <a href="https://lattes.cnpq.br/7560567213737285"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>
              <p className="descricao">
                "Dr. Henrique Güths - Fisioterapeuta
                com sólida formação acadêmica e ampla experiência em saúde, educação e promoção da qualidade de vida. 
                É Pós-Doutor em Educação pela Universidade LaSalle (2024), Doutor em Engenharia de Produção pela Universidade Federal do Rio Grande do Sul (UFRGS, 2016),
                Mestre em Ciências Cardiovasculares pela UFRGS (2004) e graduado em Fisioterapia pela Universidade Luterana do Brasil (1998).
                Atuou como Coordenador da Área da Saúde e Qualidade de Vida na Universidade LaSalle (2015–2019), além de coordenar os cursos de Fisioterapia (2009–2015 e 2020–2023) e Estética e Cosmética (2020–2021)."
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="botao-container">
        <br></br>
      </div>
    </>
  );
};

export default CorpoClinico;